import { Button, Modal } from "antd"
import DateFilter from "../../Reuseable/DateFilter/DateFilter"
import './style.scss'
import NormalButton from "../../Reuseable/NormalButton/NormalButton"
import { useState } from "react"
import dayjs from "dayjs";

export const ExportDateWiseModal = ({ loadingExport, open = true, setOpen, data = {}, handleExport = () => { } }) => {
    const [params, setParams] = useState({})

    const handleDateChange = (from, to) => {

        if (!from || !to) {
            setParams((prev) => ({
                ...prev,
                start_date: null,
                end_date: null,
            }));
            return;
        }

        setParams((prev) => ({
            ...prev,
            start_date: dayjs(from).format("YYYY-MM-DD"),
            end_date: dayjs(to).format("YYYY-MM-DD"),
        }));

    };



    return (
        <Modal title="Export Cases" centered open={open} onCancel={() => {
            setOpen(false);
            setParams({})
        }} footer={null} className="export-modal">
            <div className="exort-cases-modal-wrapper">
                <div className="header-of-export-cases-modal">
                    <DateFilter onDateChange={handleDateChange} isTruncate={false} showDate={params?.start_date && params?.end_date} />
                   {
                    !params?.start_date && !params?.end_date && (
                         <Button loading={loadingExport === data?.id} onClick={handleExport}>Export Today</Button>
                    )
                   }
                </div>
                {
                    params?.start_date && params?.end_date && (
                        <NormalButton loading={loadingExport === data?.id} onClick={() => handleExport(params)}>Export</NormalButton>
                    )
                }
            </div>
        </Modal>
    )
}